import { type UseQueryResult, useQuery } from 'react-query';
import { RsuAwardService } from '@wealthlane/api-services/wealthlane-award-service';

const useGetRsuAcceptance = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string | number;
    }>
  | undefined,
  unknown
> => {
  const rsuAcceptanceList = useQuery(
    ['getRsuAcceptanceList'],
    async () => {
      return await handleRequest(RsuAwardService.getApiAwardApiAppRSUAwardRSUAcceptances());
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return rsuAcceptanceList;
};

export default useGetRsuAcceptance;
